const ACCEPT_INVITE_ACTIONS = {
  accept: 'Não foi possível aceitar o convite.',
  load: 'Não foi possível localizar o convite.',
};

const HTTP_ERROR_DETAILS = {
  400: {
    title: 'Solicitação inválida',
    description: 'Revise os dados obrigatórios e a confirmação de maioridade.',
  },
};

const BACKEND_ERROR_DETAILS = {
  'eca_18_plus_accepted.required': {
    title: 'Confirmação de maioridade inválida',
    description: 'O servidor recusou a confirmação de maioridade enviada.',
  },
  'invite.expired': {
    title: 'Convite expirado',
    description: 'Solicite à instituição o envio de um novo convite.',
  },
};

function getResponse(error) {
  if (!error) return null;
  return error.response || error;
}

function isMachineCode(value) {
  return typeof value === 'string'
    && /^[A-Za-z0-9_.|-]+$/.test(value.trim());
}

function getSafeMessage(value) {
  if (typeof value !== 'string') return null;

  const message = value.trim().replace(/\s+/g, ' ');

  if (
    !message
    || message.length > 240
    || /<(?:!doctype|html|head|body|script)\b/i.test(message)
    || isMachineCode(message)
  ) {
    return null;
  }

  return message;
}

function getBackendError(data) {
  let code = null;
  let message = null;

  if (typeof data === 'string') {
    if (isMachineCode(data)) {
      code = data.trim();
    } else {
      message = getSafeMessage(data);
    }
  } else if (data && typeof data === 'object') {
    if (isMachineCode(data.code)) {
      code = data.code.trim();
    } else if (data.error && typeof data.error === 'object' && isMachineCode(data.error.code)) {
      code = data.error.code.trim();
    } else if (isMachineCode(data.error)) {
      code = data.error.trim();
    } else if (isMachineCode(data.message)) {
      code = data.message.trim();
    }

    message = getSafeMessage(data.message)
      || getSafeMessage(data.error && data.error.message)
      || getSafeMessage(data.error);
  }

  return { code, message };
}

function getTraceId(headers) {
  if (!headers) return null;
  if (typeof headers.get === 'function') {
    return headers.get('x-trace-id') || headers.get('X-Trace-Id') || null;
  }
  return headers['x-trace-id'] || headers['X-Trace-Id'] || null;
}

export function buildAcceptInvitePayload(values, personalTitle) {
  const payload = { ...values };

  delete payload.confirm_password;
  delete payload.email;

  return {
    ...payload,
    name: payload.name ? payload.name.trim() : '',
    personal_title: personalTitle,
    eca_18_plus_accepted: payload.eca_18_plus_accepted === true,
  };
}

export function isEca18PlusAccepted(value) {
  return value === true;
}

export function getAcceptInviteErrorDetails(error, action = 'accept') {
  const response = getResponse(error);
  const status = response && response.status;
  const backendError = response
    ? getBackendError(response.data)
    : { code: null, message: null };
  const backendCode = backendError.code;
  const traceId = response && getTraceId(response.headers);
  const knownBackendError = backendCode && BACKEND_ERROR_DETAILS[backendCode];
  const httpError = status && HTTP_ERROR_DETAILS[status];
  const errorDetails = knownBackendError || httpError || {
    title: status ? 'Erro inesperado' : 'Falha de conexão',
    description: status
      ? 'A solicitação não pôde ser concluída.'
      : 'Não foi possível obter resposta do servidor. Verifique sua conexão e tente novamente.',
  };
  const actionDescription = ACCEPT_INVITE_ACTIONS[action] || ACCEPT_INVITE_ACTIONS.accept;
  const technicalDetails = [];

  if (backendError.message) technicalDetails.push(`Detalhe: ${backendError.message}`);
  if (backendCode) technicalDetails.push(`Código: ${backendCode}.`);
  if (traceId) technicalDetails.push(`Identificador: ${traceId}.`);

  return {
    message: status
      ? `Erro ${status} — ${errorDetails.title}`
      : errorDetails.title,
    description: [
      actionDescription,
      errorDetails.description,
      ...technicalDetails,
    ].join(' '),
  };
}
